import { render, staticRenderFns } from "./AddNewProfession.vue?vue&type=template&id=285af117"
import script from "./AddNewProfession.vue?vue&type=script&lang=js"
export * from "./AddNewProfession.vue?vue&type=script&lang=js"
import style0 from "./AddNewProfession.vue?vue&type=style&index=0&id=285af117&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports